var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgShape1(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 24,
    viewBox: "0 0 20 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.8463 0C14.8463 0 12.6542 0.0100644 11.0772 2.08839C9.67471 3.93677 10.0316 5.51768 10.0316 5.51768C10.0316 5.51768 11.933 5.84632 13.6057 3.83652C15.1723 1.95406 14.8463 0 14.8463 0Z",
    fill: "#006C9C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.4903 6.50747C10.9742 6.71551 10.5502 6.88645 10.2325 6.88645C9.83647 6.88645 9.35875 6.70245 8.80368 6.48865C8.0339 6.19215 7.11537 5.83836 6.05961 5.83858C3.26323 5.83858 0.282194 8.34232 0.282194 13.1148C0.282194 17.9655 3.804 24.0004 6.59187 24.0004C7.02559 24.0004 7.5628 23.8057 8.15838 23.5899C8.89913 23.3214 9.73016 23.0203 10.5646 23.0203C11.3129 23.0203 11.9619 23.2627 12.6024 23.502C13.2264 23.7351 13.8424 23.9652 14.5343 23.9652C17.5874 23.9652 19.8476 17.6032 19.8476 17.6032C19.8476 17.6032 16.6142 16.3514 16.6142 12.7188C16.6142 9.49858 19.2097 8.17161 19.2097 8.17161C19.2097 8.17161 17.8827 5.77123 14.5092 5.77123C13.3166 5.77123 12.2923 6.18415 11.4903 6.50747Z",
    fill: "#006C9C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgShape1);
export default __webpack_public_path__ + "static/media/shape1.c953ede15603ee6f8673de427d823e71.svg";
export { ForwardRef as ReactComponent };